import { SceneId } from "../../../shared/enum";
import { DefaultVerticalMenu } from "../../components/base-menu";
import { TitleScreenOption } from "../../components/title-screen/title-screen-option";
import { StyleOptions } from "../interfaces";

export class TitleMenu extends DefaultVerticalMenu<TitleScreenOption> {
    constructor(x: number, y: number, width: number, height: number, scene: Phaser.Scene) {
        super(scene, x, y);
        this.scene = scene;
        this.width = width;
        this.height = height;

        const newGameItem = new TitleScreenOption(0, 0, "Nouvelle partie", this.scene);
        this.addMenuItem(newGameItem);
        const loadGameItem = new TitleScreenOption(0, 0, "Charger une partie", this.scene);
        this.addMenuItem(loadGameItem);

        this.centerElementsX();
        this.centerElementsY({ spaceBetween: 20 } as StyleOptions);
        this.menuItems[0].select();
    }

    public draw() {
        const graphics = this.scene.add.graphics();
        //@ts-ignore
        const menu = this.scene.add.container();
        this.menuItems.forEach((item) => menu.add(item));
    }

    public confirm() {
        if (this.menuItemIndex === 0) {
            this.scene.scene.start(SceneId.NEW_GAME_SCREEN);
        } else if (this.menuItemIndex === 1) {
            this.scene.scene.start(SceneId.LOAD_GAME_SCREEN);
        }
    }
}
